export default __webpack_public_path__ + "static/media/details-card.ec96aa11.jpg";